import { Flex } from "rebass";
import styled from "styled-components";

export const IconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin: auto;
  background: ${props => props.theme.colors.grey01};
  border-radius: 12px;

  > span {
    font-size: 18px;
  }
`;

export const InfoWrapper = styled(Flex)`
  flex-direction: column;
  gap: 16px;
  text-align: center;
  justify-content: center;
`;

export const InfoPara = styled.p`
  margin-top: 8px;
  line-height: 140%;
  font-weight: 400;
  color: ${props => props.theme.colors.text02};
`;

export const ButtonGroup = styled(Flex)`
  flex-direction: column;
  gap: 8px;
  margin-top: 32px;
`;

export const ContentWrapper = styled.div`
  max-width: 272px;
  margin: auto;
`;
